import React from 'react';

const Preview = ({ formData, getIconUrl }) => {
	return (
		<div className="w-96">
			<h3 className="text-lg font-medium text-gray-900 mb-4 text-center">
				Preview
			</h3>
			<div className="flex flex-col w-80 h-72 bg-gray-100 rounded-xl rounded-b-none justify-self-center p-4 space-y-4">
				<div className="h-full w-full bg-white rounded-lg" />
				<div className="flex flex-row items-center justify-between gap-2">
					<div className="h-16 w-16 bg-white rounded-full" />
					<div className="h-16 w-16 bg-white rounded-full" />
					<div className="h-16 w-16 bg-white rounded-full" />
					<div className="h-16 w-16 bg-white rounded-full" />
				</div>
			</div>
			<div
				className="border rounded-xl flex flex-row items-center justify-between p-3 space-x-2"
				style={{ backgroundColor: formData.bgColor }}
			>
				{formData.icon && (
					<img
						src={getIconUrl()}
						alt="App Icon"
						className="w-16 h-16 object-contain"
					/>
				)}

				<div>
					<h4
						className="text-lg font-medium mb-2"
						style={{ color: formData.titleColor.text }}
					>
						{formData.title}
					</h4>
					<p
						className="text-sm"
						style={{ color: formData.titleColor.description }}
					>
						{formData.description}
					</p>
				</div>
				<button
					className="px-4 py-2 rounded-md text-sm font-medium"
					style={{
						backgroundColor: formData.button.backgroundColor,
						color: formData.button.textColor,
					}}
				>
					{formData.button.text}
				</button>
			</div>
			<div className="flex flex-col w-80 h-8 bg-gray-100 rounded-xl rounded-t-none justify-self-center"></div>
		</div>
	);
};

export default Preview;
